<template>
  <div id="paginaVerificaBilancio">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Verifica Bilancio Coccia</b-card-title>
              <!-- <b-card-text class="mb-0"> Teatro Coccia </b-card-text> -->
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist id="dropAnniRiferimento" ref="dropAnniRiferimento" :query="queryAnno"
                  :dataSource="annoRiferimentoList" :index="annoIndex" :fields="annoRiferimentoFields"
                  :change="onAnnoRiferimentoChange" v-model="annoRiferimentoCorrente"
                  placeholder="Seleziona un Anno"></ejs-dropdownlist>
              </b-col>
              <!-- qui inserire dropdown dei mesi di cui abibamo dei bilanci consuntiv caricati -->
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist id="dropConsuntivi" ref="dropConsuntivi"
                                  :dataSource="consuntiviList" :fields="consuntiviFields"
                                  v-model="consuntivoCorrente" :enabled="dropConsuntiviEnabled"
                                  :change="onConsuntivoChange"
                ></ejs-dropdownlist>
              </b-col>
            </b-row>
            <b-row class="justify-content-md-center">
              <b-col xl="2" md="2" class="pt-5" v-show="mostraRiepilogo">
                <ejs-button id="downloadExcel" @click.native="downloadXls(false)">Scarica Verifica Bilancio</ejs-button>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";
import useJwt from "@/auth/jwt/useJwt";
// import bootstrap-Vue
import { LayoutPlugin, TabsPlugin, CardPlugin, DropdownPlugin, ImagePlugin,
  LinkPlugin, AlertPlugin, ToastPlugin,
} from "bootstrap-vue";
// import Vuexy
import { Query } from "@syncfusion/ej2-data";

// import Syncfusion
import { enableRipple } from "@syncfusion/ej2-base";
import {
  DateTimePickerPlugin,
  DateRangePickerPlugin,
  DatePickerPlugin,
  TimePickerPlugin,
} from "@syncfusion/ej2-vue-calendars";
import {
  ButtonPlugin,
  CheckBoxPlugin,
  SwitchPlugin,
} from "@syncfusion/ej2-vue-buttons";
import {
  TextBoxPlugin,
  NumericTextBoxPlugin,
  MaskedTextBoxPlugin,
  UploaderPlugin,
} from "@syncfusion/ej2-vue-inputs";
import {
  DropDownListPlugin,
  MultiSelectPlugin,
  CheckBoxSelection,
} from "@syncfusion/ej2-vue-dropdowns";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";
import {
  GridPlugin,
  Group,
  ForeignKey,
  Edit as GridEdit,
  Toolbar as GridToolbar,
  Sort as GridSort,
  Filter as GridFilter,
  Aggregate,
} from "@syncfusion/ej2-vue-grids";
import { DropDownButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";

const axios = require("axios");
// use bootstrap-vue
Vue.use(TabsPlugin);
Vue.use(CardPlugin);
Vue.use(LayoutPlugin);
Vue.use(DropdownPlugin);
Vue.use(ImagePlugin);
Vue.use(LinkPlugin);
Vue.use(AlertPlugin);
Vue.use(ToastPlugin);
// use Syncfusion
Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(MaskedTextBoxPlugin);
Vue.use(UploaderPlugin);
Vue.use(DateRangePickerPlugin);
Vue.use(DatePickerPlugin);
Vue.use(DateTimePickerPlugin);
Vue.use(TimePickerPlugin);
Vue.use(DropDownListPlugin);
Vue.use(MultiSelectPlugin);
Vue.use(ButtonPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(SwitchPlugin);
Vue.use(DialogPlugin);
Vue.use(GridPlugin);
Vue.use(DropDownButtonPlugin);
enableRipple(true);
// api
 const apiRicercaCocciaConsuntivoUrl = "/demo/api/bilanciococciaconsuntivo/ricerca"
// API ricerca distinte per anno

export default Vue.extend({
  components: {},
  data() {
    return {
      initial: true,
      dataOggi: new Date(),
      // tmp
      nonMostrare: false, // utile per non cancellare codice in editing
      // generali
      settings: {
        formatoData: { type: "date", format: "dd-MM-yyyy" }, // da usare per grid
        formatoOra: { skeleton: "Hm" },
        //formatoOra: 'HH:mm',
        formatoOraGrid: { type: "dateTime", format: "HH:mm" }, // da usare per grid
        formatoDatepicker: "dd-MM-yyyy", // da usare per i datepicker
        intervalloOra: 5,
        firstDayOfWeek: 1,
      },
      tipoFields: { text: "label", value: "val" },
      meseDict: {
        "01": "Gennaio",
        "02": "Febbraio",
        "03": "Marzo",
        "04": "Aprile",
        "05": "Maggio",
        "06": "Giugno",
        "07": "Luglio",
        "08": "Agosto",
        "09": "Settembre",
        "10": "Ottobre",
        "11": "Novembre",
        "12": "Dicembre",
      },
      annoRiferimentoList: [
        { label: "Anno 2022", val: "2022" },
        { label: "Anno 2023", val: "2023" },
        { label: "Anno 2024", val: "2024" },
        { label: "Anno 2025", val: "2025" },
        { label: "Anno 2026", val: "2026" },
      ],
      annoRiferimentoFields: { value: "val", text: "label" },
      annoIndex: -1,
      queryAnno: null,
      annoRiferimentoCorrente: null,

      consuntiviList: [],
      consuntiviFields: { value: "val", text: "label"},
      dropConsuntiviEnabled: false,
      consuntivoCorrente: null,
      mostraRiepilogo: false,
      evidenzia: 0,

      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,

      // per gridA
      gridAFlag: false,
      gridA: {
        height: 300,
        editOptions: {
          allowEditing: false,
          allowDeleting: true,
        },
        // groupOptions: { showDropArea: false, columns: ['gruppo'] },
        // sortOptions: { columns: [{ field: "data", direction: "Ascending" }] },
      },
    };
  },
  created() {
    console.log("Pagina Verifica Bilancio Creata");
    // inizializzazione elenchi dal backend
  },

  provide: {
    // per grid
    grid: [GridToolbar, GridSort, GridFilter, GridEdit, ForeignKey, Aggregate, Group],
    // per multiselect
    multiselect: [CheckBoxSelection],
  },
  methods: {
    onAnnoRiferimentoChange: function (e) {
      console.log("Change")
      console.log("Recupero dati per l'anno selezionato");
      // ricerca spettacoli stagione
      const datiDaInviare = {
        anno: this.annoRiferimentoCorrente,
      };
      useJwt.post(apiRicercaCocciaConsuntivoUrl, datiDaInviare).then((r) => {
        // mi servono i consuntivi di un certo anno, quindi devo usare API dedicata
        console.log(r.data)
        this.dropConsuntiviEnabled = true;
        this.consuntiviList = [];
        r.data.forEach((obj) => {
          this.consuntiviList.push({label: this.meseDict[obj.mese], val: obj.mese})
        })
      });
    },
    onConsuntivoChange: function (e) {
      this.mostraRiepilogo = true;
    },
    downloadXls: function() {
      // scarico statistiche spettacolo
      const datiDaInviare = {
        anno: this.annoRiferimentoCorrente,
        mese: this.consuntivoCorrente
      };
      // useJwt.post(apiBilancioProduzioneXlsUrl, datiDaInviare, { responseType: "blob" }).then((r) => {
      //   let fileName = r.headers["content-disposition"].split("filename=")[1];
      //   const url = window.URL.createObjectURL(new Blob([r.data]));
      //   const link = document.createElement("a");
      //   link.href = url;
      // 
      //   link.setAttribute("download", fileName);
      //   document.body.appendChild(link);
      //   link.click();
      // }).catch((r) => {
      //   this.makeToast("primary", "FAILURE", "Errore stagione non selezionata")
      // });
    },
    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown;
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs;
    },
    // per toast
    makeToast(variant = null, title = "titolo", message = "messaggio") {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 5000,
      });
    },
    noop() {
      console.log("premuto enter");
    },
  },
});

/* eslint-disable global-require */
</script>

<style lang="scss">
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/datepicker/material.css";
@import "~@syncfusion/ej2-dropdowns/styles/material.css";
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import "~@syncfusion/ej2-inputs/styles/material.css";
@import "~@syncfusion/ej2-vue-layouts/styles/material.css";
@import "~@syncfusion/ej2-splitbuttons/styles/material.css";
@import "~@syncfusion/ej2-grids/styles/material.css";

.e-btn-icon.e-open-icon {
  background: url("~@/assets/images/svg/open2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url("~@/assets/images/svg/garbage-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url("~@/assets/images/svg/download2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url("~@/assets/images/svg/search-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url("~@/assets/images/svg/upload-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url("~@/assets/images/svg/add2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

// seleziono il colore per evidenziare la riga selezionata
.e-grid td.e-active {
  background-color: #e5cbdd;
}
</style>
